/*!
 * 方案动作操作 v 1.0
 *
 */
import Vue from "@/main";
import * as transparencyMap from "@/components/tables/transparency/map.js";
import screenplayFn from "./screenplayFn";

/*!
  创建 Screenplay 类
  screenplay 操作数据
  fn 处理复杂操作（复杂操作可能和地图没有关联 所以不放在map里面处理）
 */
class Screenplay {
  constructor(screenplay, fn) {
    this.screenplay = screenplay;
    this.index = -1;
    this.fn = fn;
    this.timer;
    // this.addKeydown();
  }

  /**
   * 初始化
   * 初始化screenplay数据
   * @param  { Object } data - 初始化screenplay的数据
   * @returns { any }
   */
  getScreenplay(data) {
    this.screenplay = data;
    this.index = -1;
  }

  /**
   * 键盘事件
   * 添加
   *
   * @returns { any }
   */
  addKeydown() {
    window.addEventListener("keydown", this.keyDownFn);
  }

  /**
   * 键盘事件
   * 移除
   *
   * @returns { any }
   */
  removeKeydown() {
    window.removeEventListener("keydown", this.keyDownFn);
  }
  /**
   * 键盘触发事件 方便移除使用
   * 移除
   * @param  { Object } event - 键盘事件传递的参数
   * @returns { any }
   */
  keyDownFn(event) {
    if (event.keyCode == 39) {
      screenplay.nextPage();
    }
  }

  // 2.0
  initial(type = "") {
    this.index = -1;
    clearTimeout(this.timer);
    screenplayFn.kml.init();
    screenplayFn.shp.init();
    screenplayFn.roaming.init();
    screenplayFn.plot.init();
    screenplayFn.rotatePoint.init();
    screenplayFn.obliquePhotography.init(1);
    transparencyMap.adjustTileOpacity(1);
    transparencyMap.adjustTileBrightness(1);
    screenplayFn.underground.init(1);
    screenplayFn.splitScreen.init();
    screenplayFn.model.init("all");
    screenplayFn.fixedRoute.init();
    screenplayFn.fixedRoute_ptv.init();
    screenplayFn.sectioning.init();
    screenplayFn.animation.init(false);
    screenplayFn.pit.init();
    if (this.screenplay != undefined) {
      this.fn(this.screenplay[this.index], false);
    }
    if (type == "") {
      this.nextPage();
    }
  }

  /**
   * 展示
   * 下一页
   *
   * @returns { any }
   */
  nextPage() {
    if (this.screenplay) {
      if (this.screenplay.length - 1 > this.index) {
        try {
          screenplayFn.splitScreen.init();
        } catch (error) {
          console.log(error);
        }
        this.index += 1;
        this.page();
      } else {
        if (this.index != -1) {
          console.log(this.screenplay.length, this.index);
          // Vue.$notify({
          //   title: "当前场景结束",
          //   message: "",
          //   type: "info",
          //   duration: 1000,
          //   offset: 320,
          // });
        }
      }
    }
  }

  /**
   * 功能类
   * 上一页
   *
   * @returns { any }
   */
  previousPage() {
    screenplayFn.rotatePoint.fly("stop", "");
    screenplayFn.roaming.init();
    screenplayFn.splitScreen.init();
    screenplayFn.animation.init(false);
    // finalData =>最终计算出当前场景到上一步需要执行那些操作的步骤
    let finalData = [];
    //  fallbackData => 当前需要撤回操作集合
    let fallbackData;

    let cancelSplitScreenData = this.screenplay[this.index].operate.find(
      (h) => {
        return h.type == "splitScreen";
      }
    );
    if (cancelSplitScreenData) {
      fallbackData = JSON.parse(cancelSplitScreenData.property).mainScreen[0]
        .operate;
    } else {
      fallbackData = JSON.parse(
        JSON.stringify(this.screenplay[this.index].operate)
      );
    }

    // 撤回后的操作
    let previousData = JSON.parse(
      JSON.stringify(this.screenplay[this.index - 1].operate)
    );
    // complexOperation 数据代表着 这些操作类型的生命周期只有一个操作 不会继承下去
    let complexOperation = [
      "splitScreen",
      "flight",
      "roaming",
      "rotatePoint",
      "fixedRoute",
    ];
    // 查看 撤回后的操作 中是否有特殊操作
    // 后续 可以通过 item.screenplayType == "special" 来直接判断
    previousData.forEach((item) => {
      if (
        item.screenplayType == "special" ||
        complexOperation.indexOf(item.type) >= 0
      ) {
        // 如果有特殊操作的话 先把特殊操作存入 最终对象 finalData里面
        finalData.push({
          screenplayType: item.screenplayType,
          type: item.type,
          screenplayId: item.screenplayId,
          executionProperty: item.executionProperty,
          property: item.property,
        });
      }
    });
    // 在特殊对象中 还有一个特例 分屏（此方法分为主副屏幕，很多操作执行不了）
    // mainScreenData 为上一步中的分屏数据
    let mainScreenData = finalData.find((h) => {
      return h.type == "splitScreen";
    });
    // 当存在分屏时候 需要分情况讨论

    if (
      mainScreenData &&
      finalData.length > 0 &&
      mainScreenData.type == "splitScreen"
    ) {
      // deleteSplitScreenArr 为暂存数据 便于删除已找到的撤回数据
      let deleteSplitScreenArr = [];
      // 分屏的数据来自于主屏幕 mainScreen
      let mainScreen = JSON.parse(mainScreenData.property).mainScreen[0]
        .operate;
      // 遍历主屏
      mainScreen.forEach((item) => {
        // 遍历需要撤回的操作集合
        fallbackData.forEach((i, z) => {
          if (
            item.type == i.type &&
            item.executionProperty == i.executionProperty &&
            item.screenplayId == i.screenplayId
          ) {
            // 当匹配到数据后记录 fallbackData 的下标
            deleteSplitScreenArr.push(z);
          }
        });
      });
      // 循环 deleteSplitScreenArr 删除 fallbackData 已查到的数据
      // 此时 fallbackData 剩下的数据是在分屏中没有找到的
      deleteSplitScreenArr.reverse().forEach((item) => {
        fallbackData.splice(item, 1);
      });
    }
    var x = this.comparisonArray(fallbackData, this.index - 1, finalData);
    this.performAction({
      operate: this.unique(x)(),
      name: "上一步",
    });
    this.index -= 1;
  }

  /**
   * 工具类
   * 上一页
   * 此方法递归查找 当前撤回的操作 是否在之前的操作中存在 如果存在添加到finalData最终数组中 如果不存在 初始化
   * @param  { Object } data - 当前需要撤回的操作数据
   * @param  { Number } index - 操作的下标
   * @param  { Array } finalData - 输出最终的数组
   * @returns { Array } 输出最终的数组
   */
  comparisonArray(data, index, finalData = []) {
    let deleteArr = [];
    // 如果最终数组中存在了分屏 需要另行讨论
    // mainScreenData 分屏数据
    let mainScreenData = finalData.find((h) => {
      return h.type == "splitScreen";
    });
    // 循环当前 需要撤回的操作 的集合
    data.forEach((item, i) => {
      this.screenplay[index].operate.forEach((x) => {
        if (item.type == x.type && item.screenplayId == x.screenplayId) {
          console.log("步骤", item, x);
          if (item.executionProperty == x.executionProperty) {
            // 需要撤回的操作 在之前的操作中查找了 给最终数组 finalData 赋值
            if (mainScreenData) {
              JSON.parse(mainScreenData.property).mainScreen[0].operate.push({
                screenplayType: x.screenplayType,
                type: x.type,
                screenplayId: x.screenplayId,
                executionProperty: x.executionProperty,
                property: x.property,
              });
            } else {
              finalData.push({
                screenplayType: x.screenplayType,
                type: x.type,
                screenplayId: x.screenplayId,
                executionProperty: x.executionProperty,
                property: x.property,
              });
            }
            console.log("步骤", finalData);
            // deleteArr 中是需要剔除的操作 以免下次递归 重复查询
            deleteArr.push(i);
          }
          // 附加 当隐藏模型的时候 会附带把模型染色或其他针对模型的操作清除 所以当遇见了隐藏操作时 需要查找附加的属性
          if (
            item.type == "model" &&
            item.executionProperty == "show" &&
            item.property == "remove"
          ) {
            if (finalData.length > 0) {
              finalData.find((e) => {
                if (
                  e.executionProperty == x.executionProperty &&
                  e.screenplayId == x.screenplayId &&
                  e.type == x.type
                ) {
                  return false;
                } else {
                  finalData.push({
                    screenplayType: x.screenplayType,
                    type: x.type,
                    screenplayId: x.screenplayId,
                    executionProperty: x.executionProperty,
                    property: x.property,
                  });
                }
              });
            } else {
              finalData.push({
                screenplayType: x.screenplayType,
                type: x.type,
                screenplayId: x.screenplayId,
                executionProperty: x.executionProperty,
                property: x.property,
              });
            }
          }
        } else if (x.type == "splitScreen" && mainScreenData == null) {
          // 如果是分屏分话 需要从主屏找继承关系
          JSON.parse(x.property).mainScreen[0].operate.forEach((m) => {
            if (item.type == m.type && item.screenplayId == m.screenplayId) {
              if (item.executionProperty == m.executionProperty) {
                finalData.push({
                  screenplayType: m.screenplayType,
                  type: m.type,
                  screenplayId: m.screenplayId,
                  executionProperty: m.executionProperty,
                  property: m.property,
                });
                deleteArr.push(i);
              }
              // 此处特殊讨论 模型隐藏时 会导致一些针对模型的操作失效
              if (
                item.type == "model" &&
                item.executionProperty == "show" &&
                item.property == "remove"
              ) {
                if (finalData.length > 0) {
                  finalData.find((e) => {
                    if (
                      e.executionProperty == m.executionProperty &&
                      e.screenplayId == m.screenplayId &&
                      e.type == m.type
                    ) {
                      return false;
                    } else {
                      finalData.push({
                        screenplayType: m.screenplayType,
                        type: m.type,
                        screenplayId: m.screenplayId,
                        executionProperty: m.executionProperty,
                        // source: "Split screen data",
                        property: m.property,
                      });
                    }
                  });
                } else {
                  finalData.push({
                    screenplayType: m.screenplayType,
                    type: m.type,
                    screenplayId: m.screenplayId,
                    executionProperty: m.executionProperty,
                    // source: "Split screen data",
                    property: m.property,
                  });
                }
              }
            }
          });
        }
      });
    });
    if (deleteArr.length > 0)
      deleteArr.reverse().forEach((item) => {
        data.splice(item, 1);
      });
    // 撤回的操作 在之前的操作中都找到了 返回最终数据 finalData
    if (data.length === 0) return finalData;
    // 当前撤回的操作在之前的操作没有发生过时 需要调用initializeRecallData初始化没有找到的数据
    if (index - 1 < 0) return this.initializeRecallData(data, finalData);

    return this.comparisonArray(data, index - 1, finalData);
  }

  /**
   * 工具类
   * 上一页
   * 当前撤回的操作 在之前的 操作没有发生过时
   * 处理该数据，使其初始化
   *
   * @param  { Array } data - 待处理的数据
   * @param  { Array } finalData - 已有数据
   * @returns { Array } - 返回合并数据
   */

  initializeRecallData(data, finalData) {
    let temporary = [];
    let mainScreenData = finalData.find((h) => {
      return h.type == "splitScreen";
    });
    data.forEach((item) => {
      let { type, screenplayType, executionProperty, screenplayId, property } =
        item;
      console.log(
        "动画是不是没处理",
        type,
        screenplayType,
        executionProperty,
        screenplayId,
        property
      );
      if (property == "true" || property == true) {
        console.log("没有数据", item);
        if (type != "terrain" && type != "underground") {
          temporary.push({
            screenplayType: screenplayType,
            type: type,
            screenplayId: screenplayId,
            executionProperty: executionProperty,
            property: false,
          });
        }
      } else if (property == "add") {
        temporary.push({
          screenplayType: screenplayType,
          type: type,
          screenplayId: screenplayId,
          executionProperty: executionProperty,
          property: "remove",
        });
      } else if (executionProperty == "overallStaining") {
        temporary.push({
          screenplayType: screenplayType,
          type: type,
          screenplayId: screenplayId,
          executionProperty: executionProperty,
          property: "rgba(255, 255, 255, 1)",
        });
      } else if (screenplayType == "usually") {
        temporary.push({
          screenplayType: screenplayType,
          type: type,
          screenplayId: screenplayId,
          executionProperty: executionProperty,
          property: "1",
        });
      }
    });
    // 处理的分屏
    if (mainScreenData) {
      let mainScreen = (JSON.parse(
        mainScreenData.property
      ).mainScreen[0].operate = [
        ...temporary,
        ...JSON.parse(mainScreenData.property).mainScreen[0].operate,
      ]);
      let { secondaryScreen, splitScreenMode, splitScreenModePercentage } =
        JSON.parse(mainScreenData.property);
      mainScreenData.property = JSON.stringify({
        mainScreen: [
          {
            type: "usually",
            operate: mainScreen,
          },
        ],
        secondaryScreen,
        splitScreenMode,
        splitScreenModePercentage,
      });

      return finalData;
    } else {
      return [...temporary, ...finalData];
    }
  }

  /**
   * 工具类
   * 第一步 json去重
   * 第二步 给操作排序
   *
   * @param  { Array } arr - 等待去重的json去重
   * @returns { Array } - 去重后的数据
   */

  unique(arr) {
    let resultArray = [];
    arr.forEach((item) => {
      let flag = false;
      for (let i = 0; i < resultArray.length; i++) {
        if (
          item.executionProperty === resultArray[i].executionProperty &&
          item.property === resultArray[i].property &&
          item.screenplayId === resultArray[i].screenplayId &&
          item.type === resultArray[i].type
        ) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        resultArray.push(item);
      }
    });
    return function () {
      resultArray.map((item, index) => {
        if (item.executionProperty == "show" && item.property == "add") {
          resultArray.unshift(resultArray.splice(index, 1)[0]);
        }
      });
      return resultArray;
    };
  }

  /**
   * 展示
   * 下一页 预处理数据逻辑
   *
   * @returns { any }
   */
  // 2.0
  page(item = this.screenplay[this.index]) {
    /**
     * item 当前场景对象
     * currentScript 当前脚本对象
     */
    // 特殊脚本不存在继承 执行下一个脚本的时删除
    // 关于视角的操作 一定第一时间移除
    screenplayFn.rotatePoint.fly("stop", "");
    screenplayFn.roaming.init();
    screenplayFn.sectioning.init();
    screenplayFn.animation.init(false);
    this.fn(item, false);
    this.performAction(item);
  }

  /**
   * 展示
   * 执行普通操作
   *
   * @param  { Object } data - 操作的当前对象
   * @returns { any }
   */
  performAction(data) {
    // 飞行结束再加载
    let flight;
    console.log("场景数据", data);
    screenplayFn.fixedRoute.init();
    flight = data.operate.find((z) => z.type == "flight");
    if (flight == null && flight == undefined) {
      data.operate.forEach((item) => {
        // 延迟生效 delayTime
        if (item.type != "flight") {
          if (item.delay) {
            this.timer = setTimeout(() => {
              if (item.list) {
                screenplayFn[item.type][item.executionProperty](
                  item.property,
                  item.screenplayId,
                  (e) => {
                    console.log("加载完成" + e);
                  },
                  item.list
                );
              } else {
                screenplayFn[item.type][item.executionProperty](
                  item.property,
                  item.screenplayId,
                  (e) => {
                    console.log("加载完成" + e);
                  }
                );
              }
            }, item.delayTime);
          } else {
            // 马上生效
            if (item.list) {
              screenplayFn[item.type][item.executionProperty](
                item.property,
                item.screenplayId,
                (e) => {
                  console.log("加载完成" + e);
                },
                item.list
              );
            } else {
              screenplayFn[item.type][item.executionProperty](
                item.property,
                item.screenplayId,
                (e) => {
                  console.log("加载完成" + e);
                }
              );
            }
          }
        }
      });
    } else {
      screenplayFn[flight.type][flight.executionProperty](
        flight.property,
        flight.screenplayId,
        () => {
          console.log("飞行结束", data.operate);
          data.operate.forEach((item) => {
            // 延迟生效 delayTime
            if (item.type != "flight") {
              if (item.delay) {
                this.timer = setTimeout(() => {
                  if (item.list) {
                    screenplayFn[item.type][item.executionProperty](
                      item.property,
                      item.screenplayId,
                      (e) => {
                        console.log("加载完成" + e);
                      },
                      item.list
                    );
                  } else {
                    screenplayFn[item.type][item.executionProperty](
                      item.property,
                      item.screenplayId,
                      (e) => {
                        console.log("加载完成" + e);
                      }
                    );
                  }
                }, item.delayTime);
              } else {
                // 马上生效
                if (item.list) {
                  screenplayFn[item.type][item.executionProperty](
                    item.property,
                    item.screenplayId,
                    (e) => {
                      console.log("加载完成" + e);
                    },
                    item.list
                  );
                } else {
                  screenplayFn[item.type][item.executionProperty](
                    item.property,
                    item.screenplayId,
                    (e) => {
                      console.log("加载完成" + e);
                    }
                  );
                }
              }
            }
          });
        }
      );
    }
  }
}

export default Screenplay;
